export default __webpack_public_path__ + "static/media/resubmit.62e05d48.svg";